class APIS {
	apis() {
		return {
			activeCards: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/active/tickets'
			},
			historyNumbers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/resolved/tickets'
			},
			historyChat: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ticket/historychat'
			},
			inbound: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/list/inbound_messages'
			},
			outbound: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/list/wt_messages'
			},
			conversations: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ticket/chat'
			},
			historyConversations: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ticket/historychat'
			},
			historyConversationsPagination: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/history/chat'
			},
			send_text: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/text'
			},
			send: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/:type'
			},
			email: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/email'
			},
			send_template: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/template'
			},
			agent_list_a: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agentlist'
			},
			agent_admin_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agentadminlist'
			},
			agent_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agents'
			},
			transfer: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/forward/agent/:id'
			},
			end: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/chat/update/:number'
			},
			reset_group_message_count: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/messages/reset/group/:group_id'
			},
			reset_message_count: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				// path: '/messages/reset/:number'
				path: '/messages/reset'
			},
			block: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/backend/toggle/customer/block/:number'
			},
			agents_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agents'
			},
			agents_list2: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agentlist'
			},
			agents_customer_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/agent/customers'
			},
			agents_customer_conversations: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/conversations/ongoing'
			},
			unblock: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/backend/toggle/customer/unblock/:number'
			},
			allAgents: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ongoing/tickets'
			},
			inbound_messages: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/list/inbound'
			},
			outbound_messages: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/list/outbound'
			},
			search_ticket: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/search/ticket'
			},
			unassignedTickets: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/unassigned/ticket'
			},
			ongoingTicketsAgents: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ongoing/tickets/count'
			},
			typingIndicator: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/typing_indicator'
			},
			ticketReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ticket/report'
			},
			call_request: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/interactive'
			},
			// Ongoing (chatbot) tickets list — payload: { channel_type, page, limit }
			chatbotTickets: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/chatbot/tickets'
			},
			// Chat of a single ongoing (chatbot) ticket — payload: { customer_id, channel_type, page, limit }
			chatbotTicketChat: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/chatbot/ticket/chat'
			},

		};
	}
}

export default new APIS();
